import { render, staticRenderFns } from "./SideBarNewExpend.vue?vue&type=template&id=b9a5a5e6&"
import script from "./SideBarNewExpend.vue?vue&type=script&lang=js&"
export * from "./SideBarNewExpend.vue?vue&type=script&lang=js&"
import style0 from "./SideBarNewExpend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports